exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".HighlightBlock-module__HighlightBlock___2MnnQ{padding:0 0 0 24px;position:relative}.HighlightBlock-module__HighlightBlock___2MnnQ :before{content:\" \";width:3.5px;height:100%;background-color:#646464;border-radius:999px;position:absolute;left:0;top:0}", ""]);

// exports
exports.locals = {
	"HighlightBlock": "HighlightBlock-module__HighlightBlock___2MnnQ"
};